module.exports = __webpack_public_path__ + "static/plomberie3-11f0b676bf4970279ba7e8a0b8fefc68.jpg";